module.exports = __webpack_public_path__ + "static/media/9.5c4c0860.jpg";